/* ============================================================
   Wyld Chics — "Notify me" back-in-stock
   assets/wc-notify.js   (snippets/wc-notify.liquid, assets/wc-notify.css)

   Any [data-wc-notify] button opens the dialog. On submit, two calls
   straight to Klaviyo's CLIENT API (public key only, CORS-enabled):
     1. POST /client/subscriptions             profile -> "Restock
                                                Notifications" list, with
                                                the consent they ticked
     2. POST /client/back-in-stock-subscriptions
                                                variant + channels
   Klaviyo then records "Subscribed to Back in Stock" and the flow's
   Back in Stock Delay holds them until Shopify inventory comes back.
   Listeners are CAPTURE phase: tiles and the PDP live inside Alpine
   islands and bubble-phase listeners on document do not fire there.
   ============================================================ */
(function () {
  'use strict';

  var REVISION = '2026-07-15';
  var modal, ctx = null, busy = false, lastFocus = null;

  function q(sel, root) { return (root || modal).querySelector(sel); }

  function open(btn) {
    modal = modal || document.querySelector('[data-wc-notify-modal]');
    if (!modal) return;
    ctx = {
      variant: btn.getAttribute('data-variant') || '',
      product: btn.getAttribute('data-product-title') || '',
      variantTitle: btn.getAttribute('data-variant-title') || '',
      image: btn.getAttribute('data-image') || '',
      url: btn.getAttribute('data-product-url') || location.pathname
    };
    if (!ctx.variant) return;
    if (ctx.variantTitle === 'Default Title') ctx.variantTitle = '';
    var img = q('[data-wc-notify-img]');
    if (ctx.image) { img.src = ctx.image; img.hidden = false; } else { img.hidden = true; }
    q('[data-wc-notify-name]').textContent = ctx.product;
    q('[data-wc-notify-variant]').textContent = ctx.variantTitle;
    q('[data-wc-notify-form]').hidden = false;
    q('[data-wc-notify-done]').hidden = true;
    q('[data-wc-notify-error]').hidden = true;
    q('[data-wc-notify-phone-error]').hidden = true;
    q('[data-wc-notify-email]').removeAttribute('aria-invalid');
    q('[data-wc-notify-phone]').removeAttribute('aria-invalid');
    lastFocus = btn;
    modal.hidden = false;
    document.body.classList.add('wc-notify-open');
    setTimeout(function () { q('[data-wc-notify-email]').focus(); }, 50);
  }

  function close() {
    if (!modal || modal.hidden) return;
    modal.hidden = true;
    document.body.classList.remove('wc-notify-open');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  /* US numbers are the store's market: 10 digits -> +1, 11 digits starting
     with 1 -> +; anything else must already be +international */
  function e164(raw) {
    var s = (raw || '').replace(/[^\d+]/g, '');
    if (!s) return '';
    if (s[0] === '+') return /^\+\d{8,15}$/.test(s) ? s : null;
    var d = s.replace(/\D/g, '');
    if (d.length === 10) return '+1' + d;
    if (d.length === 11 && d[0] === '1') return '+' + d;
    return null;
  }

  function post(path, body, key) {
    return fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + encodeURIComponent(key), {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', 'revision': REVISION },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (r.status >= 200 && r.status < 300) return r;
      return r.text().then(function (t) { throw new Error(path + ' ' + r.status + ' ' + t.slice(0, 200)); });
    });
  }

  function submit() {
    if (busy || !ctx) return;
    var key = modal.getAttribute('data-key');
    var list = modal.getAttribute('data-list');
    var emailEl = q('[data-wc-notify-email]');
    var phoneEl = q('[data-wc-notify-phone]');
    var error = q('[data-wc-notify-error]');
    var phoneError = q('[data-wc-notify-phone-error]');
    var email = emailEl.value.trim();
    var phone = e164(phoneEl.value);
    var emailOk = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email);
    emailEl.setAttribute('aria-invalid', emailOk ? 'false' : 'true');
    phoneEl.setAttribute('aria-invalid', phoneEl.value.trim() && phone === null ? 'true' : 'false');
    error.hidden = true; phoneError.hidden = true;
    if (!emailOk || phone === null) { error.hidden = false; return; }
    /* one box covers email and text marketing. A text needs that consent,
       so a number without the box ticked is refused rather than stored. */
    var consent = q('[data-wc-notify-consent]').checked;
    if (phone && !consent) { phoneEl.setAttribute('aria-invalid', 'true'); phoneError.hidden = false; return; }
    if (!key) { error.hidden = false; return; }

    var profile = { email: email };
    if (phone) profile.phone_number = phone;
    var channels = ['EMAIL'];
    if (phone) channels.push('SMS');

    var btn = q('[data-wc-notify-submit]');
    busy = true; btn.setAttribute('aria-busy', 'true');

    var calls = [];
    if (list) {
      var subs = {};
      if (consent) subs.email = { marketing: { consent: 'SUBSCRIBED' } };
      if (consent && phone) subs.sms = { marketing: { consent: 'SUBSCRIBED' } };
      var attrs = Object.assign({}, profile);
      if (Object.keys(subs).length) attrs.subscriptions = subs;
      calls.push(post('subscriptions', {
        data: {
          type: 'subscription',
          attributes: { custom_source: 'Back in stock: ' + ctx.product, profile: { data: { type: 'profile', attributes: attrs } } },
          relationships: { list: { data: { type: 'list', id: list } } }
        }
      }, key));
    }
    calls.push(post('back-in-stock-subscriptions', {
      data: {
        type: 'back-in-stock-subscription',
        attributes: { channels: channels, profile: { data: { type: 'profile', attributes: profile } } },
        relationships: { variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + ctx.variant } } }
      }
    }, key));

    Promise.all(calls)
      .then(function () {
        var done = q('[data-wc-notify-done-text]');
        done.textContent = (done.getAttribute('data-template') || done.textContent).replace('{product}', ctx.product);
        q('[data-wc-notify-form]').hidden = true;
        q('[data-wc-notify-done]').hidden = false;
        try { window.sessionStorage.setItem('wc_notify_' + ctx.variant, '1'); } catch (e) {}
        // let the button say so if the shopper comes back to it
        document.querySelectorAll('[data-wc-notify][data-variant="' + ctx.variant + '"]').forEach(function (b) {
          if (b.getAttribute('data-done-label')) b.textContent = b.getAttribute('data-done-label');
        });
      })
      .catch(function (err) {
        error.hidden = false;
        if (window.console) console.warn('[wc-notify]', err && err.message);
      })
      .then(function () { busy = false; btn.removeAttribute('aria-busy'); });
  }

  document.addEventListener('click', function (evt) {
    var t = evt.target;
    if (!t || !t.closest) return;
    var btn = t.closest('[data-wc-notify]');
    if (btn) { evt.preventDefault(); evt.stopPropagation(); open(btn); return; }
    if (t.closest('[data-wc-notify-close]')) { evt.preventDefault(); close(); return; }
    if (t.closest('[data-wc-notify-submit]')) { evt.preventDefault(); submit(); }
  }, true);
  document.addEventListener('keydown', function (evt) {
    if (!modal || modal.hidden) return;
    if (evt.key === 'Escape') close();
    if (evt.key === 'Enter' && evt.target && evt.target.matches && evt.target.matches('[data-wc-notify-email],[data-wc-notify-phone]')) { evt.preventDefault(); submit(); }
  }, true);

  // remember the template of the done sentence before {product} is replaced
  document.addEventListener('DOMContentLoaded', function () {
    var d = document.querySelector('[data-wc-notify-done-text]');
    if (d) d.setAttribute('data-template', d.textContent);
  });
})();
